import { supportMailtoHref } from '@shared/constants';

import ReferenceCodeChip from 'src/components/atoms/ReferenceCodeChip';

interface ErrorToastActionsProps {
  /** The quotable reference code the backend published for this error. */
  referenceSlug: string;
  /** The trace behind the error, passed to support in the email body. */
  traceId?: string;
}

/** The actions on an error toast that carries a reference code: copy the code, or email support with it already filled in. */
export default function ErrorToastActions({ referenceSlug, traceId }: ErrorToastActionsProps) {
  return (
    <div className="flex items-center gap-8">
      <ReferenceCodeChip code={referenceSlug} />
      <a
        href={supportMailtoHref({ referenceSlug, traceId })}
        className="whitespace-nowrap text-12 font-medium underline"
        onClick={(e) => e.stopPropagation()}
      >
        Contact support
      </a>
    </div>
  );
}
